module.exports = __webpack_public_path__ + "static/bannner-internacionalismo-13-9840b0dc1f84d39c0fb03708d460e27c.jpeg";